import React, { useState, useEffect } from "react";
import "./App.css";
import Post from "./Post";
import SendPost from "./SendPost";

const myPostData = [{
  id: 'ABE-Maark45|gjkdflhdfgkhdfgg',
  title: 'Title of article',
  content: 'Lorem Ipsum is simply dummy text of the printing and typesetting\
  industry. Lorem Ipsum has been the industry\'s standard dummy text ever\
  since the 1500s, when an unknown printer took a galley of type and\
  scrambled it to make a type specimen book. It has survived not only\
  five centuries, but also the leap into electronic typesetting,\
  remaining essentially unchanged. It was popularised in the 1960s with\
  the release of Letraset sheets containing Lorem Ipsum passages, and\
  more recently with desktop publishing software like Aldus PageMaker\
  including versions of Lorem Ipsum.',
  time: new Date()
}]

function App() {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    const fetchPosts = async () => {
      const response = await fetch('https://workers.abemark45.workers.dev/posts', {
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
      });
      const postData = await response.json();
      setPosts(postData);
    };
    fetchPosts();
  }, []);

  return (
    <div className="App">
      <SendPost />
      {(posts && posts.length > 0) ? (
        posts.map((post) => <Post post={post} key={post.id} />)
      ) : (
        <h2>No Posts Yet!</h2>
      )}
    </div>
  );
}

export default App;
